
import Vue from 'vue'

# Mapping of Craft _typename to component
export mapping =
	blogSections_copy_BlockType: 'blog-sections-copy'
	blogSections_mediaAsset_BlockType: 'blog-sections-media-asset'

# Component def for this block
export default
	name: 'BlockList'

	props:
		sections: Array

	computed:

		# Filter the blocks to those that have been defined.  To fix errors in dev
		# environments after content model is created but commits with the new
		# block component have not been pulled down.
		createdSections: ->
			(@sections || [])
			.map (section) -> {
					...section
					componentName: mapping[section.__typename]
				}
			.filter (section) -> !!section.componentName

